import React from 'react'
import NavBar from './NavBar'
import Waves from './Waves'
import AdvertCards from './AdvertCards'
import About from './About'
import Process from './Process'
import Footer from './Footer'

const Home = () => {

  return (
    <div>
        <NavBar />
       <Waves />
       <AdvertCards />
       <About />
       <Process />
       <Footer />
    </div>
  )
}

export default Home